import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { SportSlideInProps } from "./types";
import { useMediaQuery } from "usehooks-ts";
import { SlideIn } from "@ui";
import Team from "./components/Team";
import Information from "./components/Information";

const SportSlideIn: React.FC<SportSlideInProps> = ({
  group,
  setModalState,
  modalState,
}) => {
  const smallDevice = useMediaQuery("(max-width: 576px)");
  const largeDevice = useMediaQuery("(min-width: 577px)");

  if (group)
    return (
      <>
        {modalState === true && (
          <motion.div
            key="overlay"
            onClick={() => setModalState(false)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 0.5 } }}
            exit={{ opacity: 0, transition: { delay: 0, duration: 0.4 } }}
            css={{
              position: "fixed",
              left: 0,
              top: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.3)",
              zIndex: 9,
            }}
          />
        )}
        {smallDevice && (
          <SlideIn
            open={modalState}
            cancelButtonHandler={() => setModalState(false)}
          >
            <Information
              email=""
              startalter={group.data?.start_age}
              endalter={group.data?.end_age}
              beschreibung={group.text || group.data?.description}
              key={group.objectId}
              titel={group.title || ""}
              team={group.team}
              trainingszeiten={group.times}
              info={group.description || ""}
              trainer={group.persons}
              type="mobile"
            />
          </SlideIn>
        )}

        <AnimatePresence>
          {group.team &&
            group?.team?.id &&
            modalState === true &&
            largeDevice && <Team team={group.team} key={group.team.id} />}
        </AnimatePresence>
        {largeDevice && (
          <SlideIn
            open={modalState}
            cancelButtonHandler={() => setModalState(false)}
          >
            <Information
              email=""
              startalter={group.data?.start_age}
              endalter={group.data?.end_age}
              beschreibung={group.text || group.data?.description}
              key={group.objectId}
              titel={group.title || ""}
              team={group.team}
              trainingszeiten={group.times}
              info={group.description || ""}
              type="regular"
              trainer={group.persons}
            />
          </SlideIn>
        )}
      </>
    );
  return null;
};

export default SportSlideIn;
